import {PageHeader} from 'components/PageHeader';
import {BOTTOM_BAR_BUTTONS} from 'modules/bottombar/constants';
import {useBottomBar} from 'modules/bottombar/hooks/useBottomBar';
import {CategoryPageHeader} from 'modules/categories/components/CategoryPageHeader';
import {SeoCategoryItem} from 'modules/categories/components/SeoCategoryItem';
import {CATALOG_TITLE} from 'modules/categories/constants';
import {CategorySeoPageContext} from 'modules/categories/context';
import React, {forwardRef, ReactNode, useContext, useMemo} from 'react';

import style from './style.module.scss';

export const CategorySeoPage = forwardRef<HTMLDivElement>(function CategorySeoPage(_, ref) {
    useBottomBar(BOTTOM_BAR_BUTTONS.catalog);

    const {categoriesTree} = useContext(CategorySeoPageContext);

    const renderCategoryItem = useMemo<ReactNode[]>(() => {
        if (!categoriesTree) {
            return [];
        }

        return categoriesTree.reduce<ReactNode[]>((categoryItemList, currentCategory) => {
            return [
                ...categoryItemList,
                <li className={style.seoPageListItem} key={currentCategory.id}>
                    <SeoCategoryItem {...currentCategory} />
                </li>,
            ];
        }, []);
    }, [categoriesTree]);

    return (
        <div className={style.seoPage} data-skeleton ref={ref}>
            <PageHeader>
                <CategoryPageHeader title={CATALOG_TITLE} />
            </PageHeader>
            <nav className={style.seoPageNav}>
                <ul className={style.seoPageList}>{renderCategoryItem}</ul>
            </nav>
        </div>
    );
});
